import 'date-fns'
import React from 'react'
import Grid from '@material-ui/core/Grid'
import DateFnsUtils from '@date-io/date-fns'
import {
	MuiPickersUtilsProvider,
	KeyboardTimePicker,
	KeyboardDatePicker
} from '@material-ui/pickers'

import { ThemeProvider } from '@material-ui/styles'
import { createMuiTheme } from '@material-ui/core/styles'
import { create } from 'jss'
import { StylesProvider, jssPreset } from '@material-ui/core/styles'
import rtl from 'jss-rtl'

const jss = create({ plugins: [...jssPreset().plugins, rtl()] })

const theme = createMuiTheme({
	direction: 'rtl',
	typography: {
		fontFamily: ['Cairo', 'Arial', 'sans-serif'].join(',')
	}
})

export default function MaterialUIPickers(props) {
	return (
		<ThemeProvider theme={theme}>
			<StylesProvider jss={jss}>
				<MuiPickersUtilsProvider utils={DateFnsUtils}>
					<KeyboardDatePicker
						style={{
							margin: '10px',
							...(props?.stylesh?props?.stylesh:null)
						}}
						autoOk={true}
						disableToolbar
						variant="block"
						format="yyyy/MM/dd"
						margin="normal"
						id={'date-picker-inline' + props.title}
						label={props.title}
						value={props.selectedDate}
						onChange={props.handleDateChange}
						minDate={props.minDate}
						maxDate={props.maxDate}
						KeyboardButtonProps={{
							'aria-label': 'change date'
						}}
					/>
				</MuiPickersUtilsProvider>
			</StylesProvider>
		</ThemeProvider>
	)
}
